import { render } from "./AddProfilModal.vue?vue&type=template&id=f9bcc0f2&ts=true"
import script from "./AddProfilModal.vue?vue&type=script&lang=ts"
export * from "./AddProfilModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__